//
//
//
//
//
//

export default {
    name: "ErrorComponent"
}
